export default class TimeSelector {
    constructor() {
        this.timeSelectors = document.querySelectorAll(".time-selector");
        this.bindTimeSelectors();
    }

    closestValue(value, array) {
        return array.reduce((prev, curr) => {
            if (Math.abs(curr - value) < Math.abs(prev - value)) {
                return curr;
            }

            return prev;
        });
    }

    bindTimeSelectors() {
        this.timeSelectors.forEach((timeSelector) => {
            const setTimeLink = timeSelector.querySelectorAll(".set-time");
            const setCurrentLink = timeSelector.querySelector(".set-current-time");

            if (setTimeLink) {
                setTimeLink.forEach((selector) => {
                    selector.addEventListener("click", () => {
                        const timeFields = timeSelector.querySelectorAll("select");
                        if (!timeFields.length) {
                            return;
                        }

                        timeFields[0].value = selector.dataset.timeHour;
                        timeFields[1].value = selector.dataset.timeMinute;
                    });
                });
            }

            if (setCurrentLink) {
                // TODO: check why eventlistener is only on the first `".set-current-time"`
                // and not on every `setCurrentLink`
                timeSelector.querySelector(".set-current-time").addEventListener("click", () => {
                    const timeFields = timeSelector.querySelectorAll("select");
                    if (!timeFields.length) {
                        return;
                    }

                    let hours = null;
                    let minutes = null;
                    let seconds = null;

                    const now = new Date();
                    hours = Array.prototype.filter.call(
                        Array.prototype.map.call(timeFields[0].options, option => option.value),
                        value => Number.isInteger(Number.parseInt(value, 10)),
                    );
                    timeFields[0].value = this.closestValue(now.getHours(), hours);

                    if (timeFields[1] !== undefined) {
                        minutes = Array.prototype.filter.call(
                            Array.prototype.map.call(timeFields[1].options, option => option.value),
                            value => Number.isInteger(Number.parseInt(value, 10)),
                        );
                        timeFields[1].value = this.closestValue(now.getMinutes(), minutes);
                    }

                    if (timeFields[2] !== undefined) {
                        seconds = Array.prototype.filter.call(
                            Array.prototype.map.call(timeFields[2].options, option => option.value),
                            value => Number.isInteger(Number.parseInt(value, 10)),
                        );
                        timeFields[2].value = this.closestValue(now.getSeconds(), seconds);
                    }
                });
            }
        });
    }
}
